import React from "react";
import ServicesGrid from "@/components/sections/ServicesGrid";
import ProcessSection from "@/components/sections/ProcessSection";
import ContactForm from "@/components/sections/ContactForm";
import { useLang } from "@/contexts/LanguageContext";

const Services = () => {
  const { t } = useLang();
  return (
    <div data-testid="services-page">
      <section className="bg-white border-b border-brand-border">
        <div className="container-x pt-24 pb-16 sm:pt-32 sm:pb-20">
          <p className="overline">{t.services.eyebrow}</p>
          <h1 className="mt-5 font-heading font-bold text-brand-ink text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.02] max-w-4xl">
            {t.services.title}
          </h1>
          <p className="mt-7 text-lg text-brand-muted max-w-2xl leading-relaxed">
            {t.services.subtitle}
          </p>
        </div>
      </section>
      <ServicesGrid compact />
      <ProcessSection />
      <ContactForm />
    </div>
  );
};

export default Services;
